// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"657":"40ee8594","695":"5d3b243b","805":"9a05fa60"}[chunkId] + ".chunk.css";
};